import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {formatDate} from '@angular/common';
import {DeliveryDescription} from '../model/delivery-description';
import {DeliveryType} from '../model/delivery-type';


@Pipe({
  name: 'numberProducts',
  standalone: true
})
export class NumberProductsPipe implements PipeTransform {

  constructor(private readonly translate: TranslateService) {
  }

  transform(value: DeliveryDescription | null | undefined): string {
    if (value !== undefined && value !== null) {
      if (value.deliveryType === DeliveryType.CompactRelease) {
        return this.processCompactRelease(value);
      }

      return this.processServiceReleaseHotfixMainRelease(value);
    }
    return this.translate.instant('number-products-pipe.undefined');
  }

  private processServiceReleaseHotfixMainRelease(value: DeliveryDescription): string {
    if (value.totalProducts === 0) {
      const dateToday = formatDate(new Date(), 'yyyy-MM-dd', 'en_US');
      const dateGiven = formatDate(value.deliveryDate, 'yyyy-MM-dd', 'en_US');

      if (dateGiven < dateToday) { // Check on past date
        return this.translate.instant('number-products-pipe.past_zero_programs');
      } else {
        return this.translate.instant('number-products-pipe.zero_programs');
      }
    } else if (value.totalProducts < 0) {
      return this.translate.instant('number-products-pipe.negative');
    }
    return value.totalProducts.toString();
  }

  private processCompactRelease(value: DeliveryDescription): string {
    if (value.totalProducts < 0) {
      return this.translate.instant('number-products-pipe.negative');
    }
    return this.translate.instant('number-products-pipe.main_release');
  }

}
